//韩语文件
module.exports = {
  index1: "등록하다",
  index2: "로그인",
  index3: "추가 정보",
  index3_1: "노드 가속",
  ssl: "SSL 노드 가져오기",
  ssl_copy: '성공적으로 얻었습니다. 사용하려면 응용 프로그램에 붙여넣으십시오.',
  index4: "색인",
  index5: "회사 소개",
  index6: "팔로우",
  index7: "언어",
  index8: "암호화 자산 선택",
  index9: "가장 신뢰할 수 있는 암호화폐 거래소이며 보안으로 유명합니다.",
  index10: "회원이 이미 가입했습니다!",
  index11: "오늘 무료 계정에 등록하세요!",
  index12: "지금 등록하세요!",
  index13: "시장",
  index14: "모든 혁명에는 지도자가 필요합니다.",
  index15: "최고의 거래 플랫폼은 블록체인 약속의 힘을 마스터하고 그 움직임의 일부가 되기를 원하는 사람들을 위해 설계되었습니다. 번개처럼 빠른 거래 속도, 안정적인 디지털 지갑 및 업계 최고의 보안으로 우리는 이 혁신적인 기술을 선도하는 거래소를 만들었습니다.",
  index16: "우리의 장점",
  index17: "안전 제일",
  index18: "거래소를 선택할 때 신뢰가 중요합니다. 이것이 바로 안전이 항상 우리의 최우선 고려 사항이었고 앞으로도 그럴 것입니다. 우리 플랫폼은 처음부터 구축되었으며 여러 계층의 보호 기능을 갖추고 있으며 자금 및 거래의 안전을 보장하기 위해 가장 효과적이고 신뢰할 수 있는 기술을 배포합니다.",
  index19: "단순한 거래를 넘어선 혁신",
  index20: "우리는 블록체인이 암호화를 넘어 산업 전반에 걸쳐 획기적인 솔루션을 제공할 잠재력이 있다고 믿습니다. 우리는 전 세계의 팀과 협력하여 모든 곳에서 상품, 서비스 및 운영이 관리되는 방식을 변경할 수 있는 새롭고 창의적인 토큰을 홍보하고 있습니다.",
  index21: "빠르고 강력한 기술",
  index22: "우리의 거래 엔진은 수요가 많을 때 실시간 주문 실행을 용이하게 하기 위해 규모와 속도에 맞게 사용자 정의됩니다. 우리는 다양한 API를 통해 타사 거래 플랫폼과 알고리즘 거래를 지원합니다.",
  index23: "최고의 디지털 통화 시장",
  index24: "광범위한 시장 목록을 통해 추세를 파악하고 자신 있게 거래하십시오.",
  index25: "스마트 폰",
  index26: "디지털 자산 거래 애플리케이션을 다운로드하세요!",
  index27: "스마트폰에서 직접 최고 수준의 암호화폐 거래소를 이용하세요. 이 응용 프로그램을 다운로드하여 거래하는 것이 더 쉽고 빠르고 안전합니다.",
  index28: "Apple App Store",
  index29: "Google Play Store",
  index30: "사용자 평가",
  index31: "우리는 무엇인가?",
  index32: "우리는 온라인 디지털 자산 거래 플랫폼입니다. 플랫폼에서 BTC, LTC, ETH, BCH, GDOGE, XRP, TRX, BNB 및 기타 암호화 자산과 같은 다양한 암호화 자산을 구입할 수 있습니다.",
  index33: "비트코인이란?",
  index34: "간단히 말해 비트코인은 디지털 자산입니다. 이러한 유형의 자산 거래는 신용 카드 또는 중앙 은행의 분산 없이 수행할 수 있습니다. 사용자가 매우 간단하고 효율적인 방법으로 온라인 송금을 수행할 수 있도록 설계되었습니다. 비트코인은 2009년 사토시 나카모토에 의해 개발되었습니다. 이 자산은 금과 같지만 디지털 세계에만 존재합니다. 이 개념은 디지털 금처럼 들릴 수 있지만 실제로는 상당히 다릅니다.",
  index35: "귀하의 계정에 입금하는 방법은 무엇입니까?",
  index36: '"자산 충전"을 클릭하고 "사용하려는 지불 방법"을 선택하십시오. 예: BTC, ETH, USDT. 구매하고자 하는 금액을 입력하세요. 전송할 지갑 주소를 복사합니다. 송금이 완료되면 "예금 증명서"를 작성하는 것을 잊지 마십시오. 저희 금융팀이 귀하의 입금을 확인할 때까지 기다려 주십시오. 자금은 10-30분 이내에 잔액에 표시됩니다.',
  index37: "문의하기",
  index38: "판권 소유",
  index39: "알아 채다",
  index40: "이 웹사이트의 목적은 관련성을 보여주는 것입니다.",
  index41: "앱에서 사용할 수 있는 제품 및 서비스에 대한 정보입니다. 앱에서 사용할 수 있는 제품 및 서비스에 대한 정보입니다. 그러한 제품 및 서비스에 대한 액세스를 제공할 의도가 없습니다. 앱에서 이러한 제품 및 서비스에 액세스할 수 있습니다.",
  index42: "모든 미디어 및 인터뷰 요청은 연락하십시오",
  index43: "당신의 홍보를 찾고 있습니다",
  index44: "파트너십 기회에 관심",
  index45: "일반적인 문제",
  index46: "이메일을 보내주세요",

  about1: "우리는 사용자에게 안전하고 전문적이며 편리한 디지털 통화 거래 서비스를 제공하기 위해 최선을 다하는 세계 최고의 디지털 통화 자산 거래 플랫폼입니다. 사용자의 관점에서 우리는 블록체인 분야에 대한 깊은 이해를 바탕으로 글로벌 사용자를 위한 고품질 통화를 선택하고 블록체인 기술의 트렌드를 주도합니다.",
  about2: "핵심 팀은 수석 기술 엔지니어, 글로벌 블록체인 연구 전문가, 국제 운영 팀, 세계적 수준의 위험 제어 전문가 및 기타 업계 최고의 인재를 모았습니다. 세계 최고의 암호화 기술, 자체 개발한 클러스터 메모리 매칭 시스템을 채택하고 여러 통화를 집계합니다. 다국어를 지원하며 전 세계 사용자에게 보다 안전하고 안정적이며 편리한 디지털 자산 거래를 제공하기 위해 노력하고 있습니다.",
  about3: "당사의 디지털 자산 거래 서비스 플랫폼은 디지털 자산 거래 서비스에 중점을 두고 전문 거래 기능, 스마트 거래 및 스마트 매칭, 편리한 거래, 자금 위탁 및 손쉬운 계정 관리를 제공합니다. 동시에 업계의 크고 작은 디지털 화폐 거래소와 접촉 및 협력하고 정보를 교환하고 정보를 교환하며 전 세계를 포괄하는 디지털 자산의 공통 개념에 도달합니다.",
  about4: "편리하고 부드러운 사용자 경험, 우리는 사용자의 사용 습관을 신중하게 조각하고 경험의 원칙에 따라 전체 프로세스 디자인을 수행합니다. 시스템은 7-24 중단 없는 거래 서비스 시스템 수준 보안 보호를 제공합니다. 디지털 화폐 산업을 심도 있게 육성하여 사용자에게 최고 수준의 시스템 수준 보안 보장을 제공하기 위해 디지털 화폐 산업에서 많은 R&D 인재를 축적했습니다. 다양한 국가의 디지털 통화를 지속적으로 도입하여 사용자에게 글로벌 거래 서비스, 풍부한 디지털 통화 통화를 제공하고 통화 시장에서 고품질 통화를 수집하고 포괄적인 범위의 디지털 통화를 제공합니다.",
  about5: "우리는 항상 경청하고 배려하며 앞으로 생각합니다. 암호화폐의 장점과 전통적인 금융 산업을 통합하여 계속해서 혁신할 수 있기를 바랍니다. 우수한 플랫폼 기능과 전문적인 디자인 개념을 통해 사용자에게 업계에서 가장 안전하고 효율적이며 공정하고 투명한 거래 경험을 제공합니다.",
}



// WEBPACK FOOTER //
// ./src/common/lang/ko.js